<div class="container-fluid">
    <app-pagetitle title="Stamp inventory" [actionButton]="{
    label: 'Create Stamp Order',
   onClick: navigateStampOrderCreate
  }"></app-pagetitle>

    <app-api-key-banner product="estamp"></app-api-key-banner>

    <div class="page-content-wrapper">
        <app-loader [loading]="loading"></app-loader>
        <div [class.loading-content]="loading">


            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header">
                            <app-filter searchPlaceholder="Batch Id, Serial Number, State & Stamp Value"
                                [statusOptions]="statusOptions" (filterChange)="onFilterChange($event)"
                                searchHint="Batch Id, Serial Number, State & Stamp Value">
                            </app-filter>

                            <div *ngIf="hasActiveFilters" class="text-muted small mt-2">
                                <i class="mdi mdi-information-outline me-1"></i>
                                Filters are applied to the inventory of the current page.
                            </div>
                        </div>
                        <div class="card-body">
                            <p-table #dt [value]="inventory" [lazy]="true" (onLazyLoad)="getInventory($event)"
                                [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [loading]="loading"
                                [rowsPerPageOptions]="[10,20,50]" responsiveLayout="scroll"
                                styleClass="p-datatable-sm fs-6" [showCurrentPageReport]="true"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

                                <ng-template pTemplate="header">
                                    <tr>
                                        <th>Batch Id</th>
                                        <th>Serial Number</th>
                                        <th>Stamp Value</th>
                                        <th>State</th>
                                        <th>Status</th>
                                        <th>Created</th>
                                        <th>Action</th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-document>
                                    <tr>
                                        <td class="fw-bold">{{document.batchId}}</td>
                                        <td>{{document.serialNumber}}</td>
                                        <td>₹{{document.stampValue}}</td>
                                        <td>{{document.stateName}}</td>

                                        <td>
                                            <span class="badge rounded-pill px-2 py-1 small"
                                                [ngClass]="getStatusClass(document.status)">
                                                {{ document.status }}
                                            </span>
                                        </td>

                                        <td>{{ document.createdAt | date:'dd/MM/yyyy hh:mm a' }}</td>

                                        <td class="text-center">
                                            <button class="btn btn-sm btn-light" [disabled]="!document.pdfUrl"
                                                (click)="previewFile(document)" ngbTooltip="File">
                                                <i class="mdi mdi-eye-outline"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="9" class="text-center py-4 text-muted">
                                            <i class="mdi mdi-database-off-outline me-2"></i>
                                            No document found
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        @if(showModal){
        <div class="modal fade show d-block">
            <div class="modal-dialog">
                <div class="modal-content">

                    <!-- Header -->
                    <div class="modal-header">
                        <div class="fw-bold">
                            <b>{{ orderDetail.orderId }}</b>

                            <span class="badge rounded-pill px-2 py-1 small ms-3"
                                [ngClass]="getStatusClass(orderDetail.status)">

                                {{ orderDetail.status }}
                            </span>
                        </div>

                        <button class="btn-close" (click)="closeModal()"></button>
                    </div>

                    <!-- Body -->
                    <div class="modal-body">

                        <div class="row mb-3">

                            <!-- State -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">State</div>
                                <div>{{ orderDetail.state }}</div>
                            </div>

                            <!-- Denomination -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Denomination</div>
                                <div>₹ {{ orderDetail.denomination }}</div>
                            </div>

                            <!-- First Party -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">First Party</div>
                                <div>{{ orderDetail.party?.[0]?.firstParty }}</div>
                            </div>

                            <!-- Second Party -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Second Party</div>
                                <div>{{ orderDetail.party?.[1]?.secondParty }}</div>
                            </div>

                            <!-- Purpose -->
                            <div class="col-12 mb-3">
                                <div class="fw-semibold">Purpose</div>
                                <div>{{ orderDetail.purpose }}</div>
                            </div>

                            <!-- Updated Date -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Updated At</div>
                                <div>{{ orderDetail.updatedAt | date:'medium' }}</div>
                            </div>

                            <!-- Created Date -->
                            <div class="col-6 mb-3">
                                <div class="fw-semibold">Created At</div>
                                <div>{{ orderDetail.createdAt | date:'medium' }}</div>
                            </div>

                            <!-- File Preview Button -->
                            <div class="col-6 mb-3" *ngIf="orderDetail?.fileUrl">

                                <div class="fw-semibold mb-2">Document</div>

                                <a [href]="orderDetail.fileUrl" target="_blank" class="btn btn-outline-primary btn-sm">

                                    Preview Document
                                </a>

                            </div>
                            <div class="col-6 mb-3" *ngIf="orderDetail?.invoice">

                                <div class="fw-semibold mb-2">Amount</div>

                                <div>₹ {{ orderDetail?.invoice?.amount }}</div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

        }

        @if(showModal){
        <div class="modal-backdrop fade show"></div>
        }
    </div>